module.exports = __webpack_public_path__ + "img/rightthigh-mesomorph-female.5e3990d9.svg";